// code generated by `script:genMeta` - DO NOT EDIT
export const version = 'v4.5.0';
export const versionCode = 'Krile Baldesion';
export const date = 1784797200000;
